module.exports = __webpack_public_path__ + "706b38985f259536a158ad67a3c56fb1.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_xlarge_x1/public/history/fi-1997.png
// module id = 437
// module chunks = 0